export default "__VITE_ASSET__aLOS3z7Q__"